class ProductFeedsSettings {
  constructor(appAPI) {
    'inject';

    this._appAPI = appAPI;
  }
  getAccountSettings(accountId) {
    return this._appAPI.getAccountProductFeedSettings(accountId)
    .then(({ settings }) => settings);
  }
  saveAccountSettings(accountId, newSettings) {
    return this._appAPI.saveAccountProductFeedSettings(accountId, newSettings)
    .then(({ settings }) => settings);
  }
}

export { ProductFeedsSettings };
